import { render } from "./OssUploader.vue?vue&type=template&id=5e44d944"
import script from "./OssUploader.vue?vue&type=script&lang=js"
export * from "./OssUploader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__